export const memberProfile = {
  "verified": "Vérifié",
  "online": "En ligne",
  "memberSince": "Membre depuis",
  "contact": "Contacter",
  "share": "Partager",
  "respondsIn": "Répond en",
  "responseRate": "de réponse",
  "exchangesCompleted": "Échanges réalisés",
  "reviews": "avis",
  "responseRateLabel": "Taux de réponse",
  "memberSinceLabel": "Membre depuis",
  "years": "ans",
  "year": "an",
  "exchangeHistory": "Historique des échanges",
  "property": "Logement",
  "reviewsTab": "Avis",
  "all": "Tous",
  "completed": "Terminés",
  "upcoming": "À venir",
  "cancelled": "Annulé",
  "exchangeWith": "Échange avec",
  "nights": "nuits",
  "noExchangeInCategory": "Aucun échange dans cette catégorie",
  "offeredProperty": "Logement proposé",
  "memberReviews": "Avis des membres"
};
